import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';

interface DeleteModalProps {
  templateTitle: string;
  onConfirm: () => Promise<void>;
  onClose: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  templateTitle,
  onConfirm,
  onClose
}) => {
  const handleConfirm = async () => {
    await onConfirm();
    onClose();
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.01 }}  // **ULTRA FAST**
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.99 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.99 }}
        transition={{ duration: 0.02 }}  // **ULTRA FAST**
        className="bg-white rounded-lg shadow-2xl max-w-md w-full p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">Fragebogen löschen</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md p-1"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        
        <p className="text-gray-600 mb-6">
          Möchten Sie den Fragebogen <strong>"{templateTitle}"</strong> wirklich löschen? 
          Diese Aktion kann nicht rückgängig gemacht werden.
        </p>
        
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 font-medium"
          >
            Abbrechen
          </button>
          <button
            onClick={handleConfirm}
            className="flex-1 px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 font-medium"
          >
            Löschen
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default DeleteModal;